/*
 * How long an emailed sign-in link works, in words (R-012, TDI-706).
 *
 * One place on the web side for every screen that states it: the parent's
 * "Check your email" card and the expired-link screen. The sign-in email
 * takes the same words from SIGN_IN_LINK_LIFETIME in
 * python-functions/rms_functions/rms_account_management.py; change both
 * together.
 */
export const SIGN_IN_LINK_LIFETIME = '24 hours';

export default SIGN_IN_LINK_LIFETIME;
